import { z } from 'zod';

export const stripeAccountNameSchema = z.union([z.literal('US'), z.literal('EU')]);

export type StripeAccountName = z.infer<typeof stripeAccountNameSchema>;

export type StripeAppName = 'galatea' | 'galateatv';

export type StripeCustomerIdsClaim = Partial<Record<StripeAppName, Partial<Record<StripeAccountName, string>>>>;
